export function normalizeWhatsAppNumber(value) {
    const digits = String(value || '').replace(/\D/g, '');

    if (/^0\d{9}$/.test(digits)) {
        return `27${digits.slice(1)}`;
    }

    if (/^27\d{9}$/.test(digits)) {
        return digits;
    }

    return '';
}

export function normalizeSouthAfricanMobileInput(value) {
    const digits = String(value || '').replace(/\D/g, '');
    if (/^27\d{9}$/.test(digits)) return `0${digits.slice(2)}`;
    return digits.slice(0, 10);
}

export function isSouthAfricanMobileNumber(value) {
    return /^0\d{9}$/.test(String(value || '').replace(/\D/g, ''));
}

export function buildWhatsAppUrl(number, message) {
    const normalizedNumber = normalizeWhatsAppNumber(number);
    if (!normalizedNumber || !message?.trim()) return '';
    return `https://wa.me/${normalizedNumber}?text=${encodeURIComponent(message.trim())}`;
}
